import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector } from 'redux-form';

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Table from '../common/table/table';
import THead from '../common/table/tHead';
import Tr from '../common/table/tr';
import Th from '../common/table/th';
import TBody from '../common/table/tBody';
import Td from '../common/table/td';
import ButtonTable from '../common/table/buttonTable';
import Button from '../common/button/button';
import Form from './grupoFaturamentoRadiologistaForm';
import { setError } from '../common/toast/toast';
import readXlsxFile from 'read-excel-file/web-worker'
import Aguardando from '../common/template/aguardando';

import { setModoTela, initForm, salvar, excluir, getLista } from './grupoFaturamentoRadiologistaActions';
import { setModoTela as setModoTelaGrupoFaturamento } from '../grupoFaturamento/grupoFaturamentoActions';
import { getLista as getListaRadiologista } from '../radiologista/radiologistaActions';
import FormatUtils from '../common/formatUtils/FormatUtils';

class GrupoFaturamentoRadiologista extends Component {

	state = {
		linhaSelecionada: null
	}

	componentDidMount() {

	}

    componentWillMount() {
        this.props.getLista(this.props.id_grupo_faturamento);
		this.props.getListaRadiologista();
    }

    render() {
        return (
            <div>
                <Content>
					<Aguardando aguardando={this.props.aguardando} />

					{this.props.modoTela == 'cadastro' ? (
						<Form onSubmit={this.props.salvar} />
					) : null}
					{this.props.modoTela == 'exclusao' ? (
						<Form excluir onSubmit={this.props.excluir} />
					) : null}
					{this.props.modoTela == 'lista' ? this.lista() : null}
                </Content>
            </div>
        )
    }

	lista() {

		let lista = (this.props.lista).filter(item => {
			if (this.state.pesquisar
				&& !(`${item.nome} ${item.nome_fantasia_radiologista}`).toUpperCase().includes(this.state.pesquisar.toUpperCase())) {
				return false;
			}
			return true;
		});

		return (
			<ContentCard>
				<ContentCardHeader>
					<Row>
						<Grid cols='6 6 4 2'>
							<Button
								text='Adicionar'
								type={'success'}
								icon={'fa fa-plus'}
								event={() => {
									this.props.setModoTela('cadastro', {});
									this.props.initForm({ id_grupo_faturamento: this.props.id_grupo_faturamento });
								}} />
						</Grid>
						<Grid cols='6 6 4 2'>
							<Button
								text='Voltar'
								type={'warning'}
								icon={'fa fa-plus'}
								event={() => {
									this.props.setModoTelaGrupoFaturamento('lista');
									this.props.getLista(0);
								}} />
						</Grid>
					</Row>
				</ContentCardHeader>
				<ContentCardBody>
					<Table responsive>
						<THead>
							<Tr>
								<Th>Radiologista</Th>
								<Th></Th>
							</Tr>
						</THead>
						<TBody>
							{lista.map(item => (
								<Tr key={item.id} className={`${this.state.linhaSelecionada == item.id ? 'hover' : ''}`}
									onClick={() => this.setState({ ...this.state, linhaSelecionada: item.id })}
									onMouseEnter={() => this.setState({ ...this.state, linhaSelecionada: item.id })} >
									<Td>{item.nome_radiologista}</Td>
									<Td alignRight minWidth={10}>																			
										{/*<ButtonTable
											type={'warning'}
											icon={'fas fa-pencil-alt'}
											visible={this.state.linhaSelecionada == item.id}
											event={() => {
												this.props.setModoTela('cadastro', {
													...item
												});
												this.props.initForm({
													...item
												});
											}} />*/}

										<ButtonTable
											type={'danger'}
											icon={'fas fa-trash-alt'}
											visible={this.state.linhaSelecionada == item.id}
											event={() => {
												this.props.setModoTela('exclusao', {
													...item
												});
												this.props.initForm({
													...item
												});
											}} />
									</Td>
								</Tr>
							))}
						</TBody>
					</Table>
				</ContentCardBody>
			</ContentCard>
		);
	}
}

const mapStateToProps = state => ({
	sessao: state.auth.usuario,
	modoTela: state.grupoFaturamentoRadiologista.modoTela,
	aguardando: state.grupoFaturamentoRadiologista.aguardando,
	lista: state.grupoFaturamentoRadiologista.lista
});
const mapDispatchToProps = dispatch => bindActionCreators({ 
	setModoTela, initForm, salvar, excluir, getLista, getListaRadiologista, setModoTelaGrupoFaturamento
}, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(GrupoFaturamentoRadiologista);